export default __webpack_public_path__ + "003649499d95d8e029967c50016c4b95.woff2";